import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import genericSelectSlice from 'modules/global/reducers/generic.selectSlice';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/payers/actionTypes';
import { PAYER_DASHBOARD_SOURCE, PAYER_DETAILS_SOURCE } from 'modules/payers/constants';
import loadingSlice from 'modules/payers/reducer/ui/loading';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import filters from './filters';

/**
 * @typedef {{
 *   deleting: string[],
 *   filters: import('./filters').PayersFiltersReducer,
 *   data: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * }} PayerUIDdashboardReducer
 */

/**
 * @typedef {{
 *   loading: {
 *     update: boolean,
 *     create: boolean,
 *     fetch: boolean,
 *   },
 *   ready: boolean,
 * }} PayerUIDetailsReducer
 */

/**
 * @typedef {{
 *   details: PayerUIDetailsReducer,
 *   dashboard: PayerUIDdashboardReducer,
 *   selects: import("modules/global/reducers/generic.selectSlice").GenericSelectsReducer
 * }} PayerUIReducer
 */

const flushSelects = (state, { payload }) => (payload.action === 'REPLACE' ? state : {});

export default combineReducers({
  dashboard: combineReducers({
    filters,
    deleting: loadingSlice(types.DELETE_PAYER, { matcher: ({ meta }) => meta?.source === PAYER_DASHBOARD_SOURCE }),
    data: createSearchReducers(types.FETCH_PAYERS, {
      global: { matcher: ({ meta }) => meta?.source === PAYER_DASHBOARD_SOURCE, paginationSlice: true },
    }),
  }),
  details: combineReducers({
    loading: combineReducers({
      update: loading(types.PUT_PAYER),
      create: loading(types.POST_PAYER),
      fetch: loading(types.FETCH_PAYER, { global: { matcher: ({ meta }) => meta?.source === PAYER_DETAILS_SOURCE } }),
    }),
    ready: createReducer(false, {
      [types.SET_IS_READY]: () => true,
      [LOCATION_CHANGE]: () => false,
    }),
  }),
  selects: genericSelectSlice(types.FETCH_AVAILABLE_PAYERS, {
    reducers: { [LOCATION_CHANGE]: flushSelects },
  }),
});
